// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__32fAo","label":"Completed_label__15oXl"};